module.exports = __webpack_public_path__ + "static/media/NatConOp.1f948787.png";